export default {
  data() {
    return {
      selectedItems: [],
    };
  },

  methods: {
    onRowClick(item, index) {
      const selectedItemIndex = this.selectedItems.indexOf(item);

      if (selectedItemIndex > -1) {
        this.selectedItems.splice(selectedItemIndex, 1);
        delete this.items[index]._rowVariant;
      } else {
        this.selectedItems.push(item);
        this.items[index]._rowVariant = 'selected';
      }
    },

    showAsSelected(index) {
      const item = this.items[index];

      if (this.selectedItems.includes(item)) {
        this.items[index]._rowVariant = 'selected';
      } else {
        delete this.items[index]._rowVariant;
      }
    },
  },

  computed: {
    selectAll: {
      get() {
        return this.selectedItems.length === this.items.length;
      },

      set(allSelectedValue) {
        if (allSelectedValue) {
          const selectedItems = [];

          this.items.forEach((item) => {
            selectedItems.push(item);
            item._rowVariant = 'selected';
          });
          this.selectedItems = selectedItems;
        } else if (this.selectedItems.length === this.items.length) {
          this.selectedItems = [];
          this.items.forEach((item) => {
            delete item._rowVariant;
          });
        }
      },
    },
  },
};
